"use strict";

var prodDomain = "https://portal.binderpos.com";
//var devDomain = "https://c88097aa.ngrok.io";
var devDomain = "https://appbeta.binderpos.com";

var currencyFormatter = document.querySelector('.currencyFormatter').value
var primaryColor = document.querySelector('.primaryColour').value;
var storeUrl = document.querySelector('.primaryDomain').value;
var primaryDomain = document.querySelector('.primaryDomain').value;
var customerId = document.querySelector('.customerId').value



// BinderPOS AJAX
function addToCart(item, itemTitle, maxStock, qty, callback) {
  return $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "json",
    data: 'quantity=' + qty + '&id=' + item,
    success: function () {
      var cartCountDiv = document.querySelector('.cart-overview').querySelector('span');
      var mobileCount = document.querySelector('.mobileCartIcon').querySelector('span');
      mobileCount.innerHTML = "(" + (parseInt(cartCountDiv.innerHTML) + parseInt(qty)) + ") <i class='fas fa-shopping-cart'></i>";
      cartCountDiv.innerHTML = parseInt(cartCountDiv.innerHTML) + parseInt(qty);
      Toastify({
        text: qty + " x " + itemTitle + " added to cart",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(true);
      }
    },
    error: function () {
      Toastify({
        text: "All " + maxStock + " " + itemTitle + "s are in the Cart",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: "red",
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(false);
      }
    }
  });
}

function updateCart(item, itemTitle, qty, callback) {
  return $.ajax({
    url: "/cart/update.js",
    type: "POST",
    dataType: "json",
    data: 'updates[' + item + '=' + qty,
    success: function () {
      Toastify({
        text: itemTitle + " updated",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(true, item);
      }
    },
    error: function () {
      Toastify({
        text: "Error Deleting Item",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: "red",
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(false, item);
      }
    }
  });
}

function deleteCartItem(item, itemTitle, qty, callback) {
  return $.ajax({
    url: "/cart/update.js",
    type: "POST",
    dataType: "json",
    data: 'updates[' + item + '=' + qty,
    success: function () {
      Toastify({
        text: itemTitle + " was deleted from the cart",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(true, item);
      }
    },
    error: function () {
      Toastify({
        text: "Error Deleting Item",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: "red",
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(false, item);
      }
    }
  });
}

//Retieve Cart Items Products Page Info
function getCartItems(callback) {
  return $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    success: function (result) {
      if (callback) {
        callback(result.items);
      }
    },
    error: function () {
      if (callback) {
        callback(false);
      }
    }
  });
}

//cart updates
function getCartItemsUpdate(callback) {
  return $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    success: function (result) {
      if (callback) {
        callback(result);
      }
    },
    error: function () {
      if (callback) {
        callback(false);
      }
    }
  });
}

function addedToWishlist(storeUrl, customerId, callback) {
  return $.ajax({
    url: (storeUrl == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/wishlist/forMe?storeUrl=" + storeUrl + "&shopifyCustomerId=" + customerId,
    type: "GET",
    dataType: "json",
    success: function (result) {
      if (callback) {
        callback(result);
      }
    },
    error: function () {
      if (callback) {
        callback(false);
      }
    }
  });
}

//function addToWishlist
function addToWishlist(id, customer, storeUrl, qty, callback) {
  var obj = JSON.stringify({
    "customerId": customer,
    "variantId": id,
    "quantity": qty,
  });
  return $.ajax({
    url: (storeUrl == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/wishlist/add?storeUrl=" + storeUrl,
    type: "POST",
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: obj,
    success: function (result) {
      refreshWishlistCount();
      Toastify({
        text: "Added to Wishlist",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(result);
      }
    },
    error: function (result) {
      Toastify({
        text: result.responseJSON.detailedMessage,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: "red",
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
    }
  });
}

//function Remove from wishlist
function removeWishlist(id, customer, storeUrl, callback) {
  return $.ajax({
    url: (storeUrl == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/wishlist/delete/item/forMe?storeUrl=" + storeUrl + "&shopifyCustomerId=" + customer + "&shopifyVariantId=" + id,
    type: "DELETE",
    dataType: "json",
    success: function (result) {
      refreshWishlistCount();
      Toastify({
        text: "Removed from Wishlist",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      if (callback) {
        callback(result);
      }
    },
    error: function (result) {
      console.log(result);
    }
  });
}

//Show Wishlist
function showWishlist() {
  var wishlistOverlay = document.querySelector('#wishlistOpened');
  var clostBtn = document.querySelector('#wishlist-close-button');
  var body = document.querySelector('.bodyScroll');
  body.classList.add('noscroll');
  wishlistOverlay.classList.remove('hide');
  wishlistOverlay.addEventListener("click", function (e) {
    if (e.target == wishlistOverlay || e.target == clostBtn) {
      wishlistOverlay.classList.add('hide');
      var body = document.querySelector('.bodyScroll');
      body.classList.remove('noscroll');
      refreshWishlistCount()
    }
  });
}

//truncate text
function text_truncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

//show Decklist

function showDecklist(oldSearch) {
  var body = document.querySelector('.bodyScroll');
  body.classList.add('noscroll');
  var decklistOverlay = document.querySelector('#decklistOpened');
  var clostBtn = document.querySelector('#decklist-close-button');
  var deckListBody = document.querySelector('#deckListBody');
  if (oldSearch) {
    deckListBody.innerHTML = "";
    var buttonText = decklistOverlay.querySelector('#decklistAction button');
    buttonText.innerHTML = "Submit deck list";
  }
  var decklistBtnAction = document.querySelector('#decklistAction button');
  decklistOverlay.classList.remove('hide');
  decklistOverlay.addEventListener("click", function (e) {
    if (e.target == decklistOverlay || e.target == clostBtn) {
      decklistOverlay.classList.add('hide');
      deckListBody.innerHTML = "";
      decklistBtnAction.innerHTML = "Submit deck list"
      var body = document.querySelector('.bodyScroll');
      body.classList.remove('noscroll');
    }
  });
  $.ajax({
    url: (storeUrl == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/supportedGames?storeUrl=" + primaryDomain,
    type: "GET",
    dataType: "json",
    success: function (games) {
      var gameSelector = document.createElement('select');
      gameSelector.id = "gameType";
      deckListBody.appendChild(gameSelector);
      games.forEach(game => {
        var gameSelect = document.querySelector('#gameType');
        var opt = document.createElement('option');
        opt.appendChild(document.createTextNode(game.gameName.substring(0, 24)));
        opt.value = game.gameId;
        if (game.gameId == "mtg") {
          opt.selected = true;
        }
        gameSelect.appendChild(opt);
      });
    }
  });
  var deckListInput = document.createElement('textarea');
  deckListInput.id = "deck-builder";
  if (oldSearch) {
    deckListInput.value = oldSearch;
    if (deckListInput.value.length > 0) {
      deckListInput.style.background = "white";
    } else {
      deckListInput.style.background = "transparent";
    }
  }
  var decklistTextImgWrapper = document.createElement('div');
  decklistTextImgWrapper.className = "textImgWrapper";
  var decklistTextImg = document.createElement('img');
  decklistTextImg.src = "https://storage.googleapis.com/binderpos-libraries/buylistCards.png";
  var decklistText = document.createElement('span');
  decklistText.innerHTML = "Paste your decklist here using MTGGoldfish format <br><br>Example<br>------------------<br>3 Beanstalk Giant<br>  4 Fae of Wishes<br>   3 Hydroid Krasis<br>   4 Golos, Tireless Pilgrim<br>  2 Kenrith, the Returned King<br>   2 Forest";
  deckListInput.addEventListener('input', () => {
    var textLn = deckListInput.value.length;
    if (textLn >= 1) {
      deckListInput.style.background = "white";
    } else {
      deckListInput.style.background = "transparent";
    }
  });
  decklistTextImgWrapper.appendChild(decklistTextImg);
  decklistTextImgWrapper.appendChild(decklistText);
  deckListBody.appendChild(decklistTextImgWrapper);
  deckListBody.appendChild(deckListInput);
  decklistBtnAction.onclick = processDeckList;
}

// Process Deck List
function processDeckList() {
  var backData = $('#deck-builder').val()
  var deckList = $('#deck-builder').val().split('\n');
  var deckBody = document.querySelector('#deckListBody');
  var loader = document.querySelector('#savedLoader');
  var type = "mtg";
  var gameSelector = document.querySelector('#gameType');
  if (gameSelector) {
    type = document.querySelector('#gameType option:checked').value;
  }
  deckBody.innerHTML = loader.innerHTML;
  deckList = parseDeckList(deckList)
  return $.ajax({
    url: "https://portal.binderpos.com/external/shopify/decklist?storeUrl=" + storeUrl + "&type=" + type,
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(deckList),
    success: function (result) {
      console.log(result)
      deckBody.innerHTML = "";
      var backBtn = document.createElement('span');
      backBtn.className = "backBtn";
      backBtn.innerHTML = "<i class='fas fa-long-arrow-alt-left'></i> Re-enter list";
      backBtn.addEventListener("click", function () {
        showDecklist(backData);
      });
      deckBody.appendChild(backBtn);
      var decklistBtnAction = document.querySelector('#decklistAction button');
      decklistBtnAction.innerHTML = "Add selected cards to cart"
      decklistBtnAction.onclick = compileDeckList;
      var decklistActions = document.createElement('div');
      decklistActions.className = "decklistActions";
      var checkboxallLabel = document.createElement('label');
      checkboxallLabel.className = "checkbox";
      var checkboxallInput = document.createElement('input');
      checkboxallInput.type = "checkbox";
      checkboxallInput.onclick = toggleall;
      checkboxallInput.checked = true
      var checkboxallSpan = document.createElement('span');
      checkboxallSpan.className = "checkmark";
      var labelText = document.createElement('p');
      labelText.innerHTML = "Select all"
      checkboxallLabel.appendChild(checkboxallInput);
      checkboxallLabel.appendChild(checkboxallSpan);
      checkboxallLabel.appendChild(labelText);
      var totals = document.createElement('div');
      totals.className = "totals";
      totals.innerHTML = "Total:"
      var totalAmount = document.createElement('em');
      totalAmount.className = "totalAmmount";
      totalAmount.innerHTML = Shopify.formatMoney((0), currencyFormatter);
      totals.appendChild(totalAmount);
      decklistActions.appendChild(checkboxallLabel);
      decklistActions.appendChild(totals);
      deckBody.appendChild(decklistActions);
      var notFoundList = [];
      result.forEach(function (resultLine) {
        if (resultLine.found == 0) {
          notFoundList.push(resultLine);
        }
        var options;
        if (resultLine.products.length > 0) {
          options = resultLine.products;
        }
        var added = 0;
        resultLine.products.forEach(function (item) {
          var requested = resultLine.requested;
          var avaialable = item.variants[0].quantity;
          if (added < requested) {
            var itemMax = 0;
            if ((requested - added) < avaialable) {
              itemMax = avaialable;
            } else {
              itemMax = avaialable;
            }
            if (avaialable > requested) {
              itemMax = requested - added;
            }
            added += avaialable;
            decklistItem(item, deckBody, itemMax, avaialable, options);
          }
        })
      });
      // Activate swap toggle
      swapToggle()
      toggleall()
      notFoundList.forEach(function (element) {
        noDeckListItem(deckBody, element.searchName, element.validName, element.imageUrl, element.requested);
      });
    },
    error: function (result) {
      console.log("Error below")
      console.log(result);
    }
  });
}
//Decklist No Stock & Failed Items
function noDeckListItem(deckBody, name, valid, imgUrl, requested) {
  var deckListItem = document.createElement('div')
  deckListItem.id = "deckItem";
  if (valid == false) {
    deckListItem.style.background = "#efeeee";
  }
  deckListItem.className = "decklistItem nostockAvail";
  deckBody.appendChild(deckListItem);
  var img = document.createElement('img');
  img.className = "decklistImg";
  if (valid) {
    img.src = imgUrl;
  } else {
    img.src = "https://storage.googleapis.com/binderpos-libraries/cardNoImage.png";
  }
  deckListItem.appendChild(img);
  var ammountDiv = document.createElement('div');
  ammountDiv.className = "required";
  var selectedAmmount = document.createElement('span');
  selectedAmmount.className = "selectedAmount";
  selectedAmmount.innerHTML = "0";
  var requestedAmmount = document.createElement('span');
  requestedAmmount.className = "requestedAmount";
  requestedAmmount.innerHTML = "/" + requested;
  ammountDiv.appendChild(selectedAmmount);
  ammountDiv.appendChild(requestedAmmount);
  deckListItem.appendChild(ammountDiv);
  var info = document.createElement('div');
  info.className = "decklistTitleNoStock";
  info.innerHTML = text_truncate(name, 35, "...");
  deckListItem.appendChild(info);
  if (valid) {
    var price = document.createElement('div');
    price.className = "linePrice";
    price.innerHTML = "?";
    price.style.marginLeft = "16px";
    deckListItem.appendChild(price);
    var noStock = document.createElement('div');
    noStock.className = "noStock";
    noStock.innerHTML = "No stock";
    deckListItem.appendChild(noStock);
  } else {
    var unknownCard = document.createElement('div');
    unknownCard.className = "unknown";
    unknownCard.innerHTML = "Unknown card";
    deckListItem.appendChild(unknownCard);
  }
}


//Decklist Line Items
function decklistItem(item, deckBody, itemMax, avaialable, options, swap) {
  var currentLine = item.variants[0]
  if (swap != "true") {
    // New Item
    var deckListItem = document.createElement('div')
    deckListItem.id = "deckItem" + currentLine.shopifyId;
    deckListItem.className = "decklistItem";
    deckBody.appendChild(deckListItem);
  } else {
    // If item already exists, dont create a new div. Swap the details
    deckListItem = document.querySelector("#deckItem" + currentLine.shopifyId);
  }
  var checkboxLabel = document.createElement('label');
  checkboxLabel.className = "checkbox";
  var checkboxInput = document.createElement('input');
  checkboxInput.type = "checkbox";
  checkboxInput.onclick = toggleOne;
  var checkboxSpan = document.createElement('span');
  checkboxSpan.className = "checkmark";
  checkboxLabel.appendChild(checkboxInput);
  checkboxLabel.appendChild(checkboxSpan);
  var img = document.createElement('img');
  img.className = "decklistImg";
  img.src = item.img;
  var price = document.createElement('div');
  price.className = "linePrice";
  price.setAttribute("data-price", currentLine.price);
  price.innerHTML = Shopify.formatMoney(((currentLine.price) * 100), currencyFormatter);
  console.log(price);
  if (options.length == 1) {
    price.style.marginLeft = "16px";
  }
  var ammountDiv = document.createElement('div');
  ammountDiv.className = "required";
  var selectedAmmount = document.createElement('span');
  selectedAmmount.className = "selectedAmount";
  selectedAmmount.innerHTML = itemMax;
  var requestedAmmount = document.createElement('span');
  requestedAmmount.className = "requestedAmount";
  requestedAmmount.innerHTML = "/" + itemMax;
  ammountDiv.appendChild(selectedAmmount);
  ammountDiv.appendChild(requestedAmmount);
  var info = document.createElement('div');
  info.className = "decklistTitle";
  var cardName = item.extendedName;
  info.innerHTML = text_truncate(cardName, 35, "...") + "<br> <em class='setName'>" + text_truncate(item.setName, 35, "...") + "</em><br><em>- " + currentLine.title + "</em>";
  var qtyWrapper = document.createElement('div');
  qtyWrapper.className = "qtyWrapper";
  var addAmount = document.createElement('input');
  addAmount.type = "number";
  addAmount.min = "0";
  addAmount.max = avaialable;
  addAmount.value = itemMax;
  addAmount.addEventListener("change", function () {
    decklistQty(currentLine.shopifyId);
  });
  var plusBtn = document.createElement('span');
  plusBtn.className = "addQty";
  plusBtn.innerHTML = "+";
  var minusBtn = document.createElement('span');
  minusBtn.className = "minusQty";
  minusBtn.innerHTML = "-";
  plusBtn.addEventListener("click", function () {
    decklistQty(currentLine.shopifyId, "add");
  });
  minusBtn.addEventListener("click", function () {
    decklistQty(currentLine.shopifyId, "remove");
  });
  deckListItem.appendChild(checkboxLabel);
  deckListItem.appendChild(img);
  deckListItem.appendChild(ammountDiv);
  deckListItem.appendChild(info);
  // If other Card Options then show switcher
  if (options.length > 1) {
    var swapIcon = document.createElement('i');
    swapIcon.className = "fas fa-exchange-alt";
    deckListItem.appendChild(swapIcon);
    // Add event listener to new replaced Item
    if (swap == "true") {
      swapIcon.addEventListener("click", function (e) {
        var lineItem = e.target.parentNode;
        var menuDiv = lineItem.querySelector('.optionsWrapper');
        if (menuDiv.style.display == "block") {
          menuDiv.style.display = "none";
        }
        else {
          menuDiv.style.display = "block";
        }
      });
    }
    var optionsDiv = document.createElement('div');
    optionsDiv.className = "optionsWrapper";
    var headerLine = document.createElement('div');
    headerLine.className = "optionsHeaders";
    headerLine.innerHTML = "<div class='row'><div class='col-md-5 left-align'>Card Title</div><div class='col-md-2'>Condtion</div><div class='col-md-2'>Price</div><div class='col-md-3'>Availability</div></div>"
    optionsDiv.appendChild(headerLine);
    options.forEach(function (element) {
      // Show card options that not the Current or curent cpndtion
      if (element.extendedName != item.extendedName) {
        var optionLine = document.createElement('div');
        optionLine.id = "option-" + element.shopifyId;
        var fullName = element.extendedName + " [" + element.setName + "]";
        optionLine.innerHTML = "<div class='optionStyle'><div class='row'><div class='col-md-5 left-align'>" + text_truncate(fullName, 37, "...") + "</div><div class='col-md-2'>" + element.variants[0].title + "</div><div class='col-md-2'>" + Shopify.formatMoney(((element.variants[0].price) * 100), currencyFormatter) + "</div><div class='col-md-3'>" + element.variants[0].quantity + "  in Stock</div></div></div>";
        optionsDiv.appendChild(optionLine);
        optionLine.addEventListener("click", function () {
          swapLineItem(currentLine.shopifyId, element, itemMax, options);
        });
      } else if (element.variants[0].title != currentLine.title) {
        // If set did match, show other conditions available.
        var optionLine = document.createElement('div');
        optionLine.id = "option-" + element.shopifyId;
        optionLine.innerHTML = "<div class='optionStyle'><div class='row'><div class='col-md-5 left-align'>" + element.extendedName + " [" + element.setName + "]</div><div class='col-md-2'>" + element.variants[0].title + "</div><div class='col-md-2'>" + Shopify.formatMoney(((element.variants[0].price) * 100), currencyFormatter) + "</div><div class='col-md-3'>" + element.variants[0].quantity + "  in Stock</div></div></div>";
        optionsDiv.appendChild(optionLine);
        optionLine.addEventListener("click", function () {
          swapLineItem(currentLine.shopifyId, element, itemMax, options);
        });
      }
    });
    deckListItem.appendChild(optionsDiv);
  }
  deckListItem.appendChild(price);
  deckListItem.appendChild(qtyWrapper);
  qtyWrapper.appendChild(minusBtn);
  qtyWrapper.appendChild(addAmount);
  qtyWrapper.appendChild(plusBtn);
  if (itemMax == avaialable) {
    plusBtn.classList.add("maxed");
  }
}

//Swap Decklist Items menu toggle
function swapToggle() {
  var list = [];
  list = document.querySelectorAll('.fa-exchange-alt');
  if (list) {
    list.forEach(function (element) {
      element.addEventListener("click", function (e) {
        var lineItem = e.target.parentNode;
        var menuDiv = lineItem.querySelector('.optionsWrapper');
        if (menuDiv.style.display == "block") {
          menuDiv.style.display = "none";
        }
        else {
          menuDiv.style.display = "block";
        }
      });
    });
  }


}
//Swap Decklist items
function swapLineItem(oldLineId, newLineData, requestQty, options) {
  var deckBody = document.querySelector('#deckListBody');
  var oldDiv = document.querySelector("#deckItem" + oldLineId);
  var state = document.querySelector('.decklistActions input');
  oldDiv.id = "deckItem" + newLineData.variants[0].shopifyId;
  oldDiv.innerHTML = "";
  state.checked = false;
  decklistTotals()
  decklistItem(newLineData, deckBody, requestQty, newLineData.variants[0].quantity, options, "true")
}

// Parse Decklist
function parseDeckList(list) {
  var result = [];
  var i = 0;
  for (i = 0; i < list.length; i++) {
    if (list[i]) {
      var parsedLine = list[i].match(/([0-9]+) (.+)/);
      // Fix is Qty not inputted with decklist
      if (!parsedLine) {
        parsedLine = [null, 1, list[i]];
      }
      if (parsedLine) {
        result.push({ card: parsedLine[2], quantity: parsedLine[1] });
      }
    }
  }
  return result;
}

function decklistTotals() {
  var total = document.querySelector('.totals em');
  var list = document.querySelectorAll('.decklistItem input:checked');
  var parentlist = [];
  for (var i = 0; i < list.length; i++) {
    parentlist.push(list[i].parentNode.parentNode.querySelector('.linePrice').getAttribute('data-price') * list[i].parentNode.parentNode.querySelector('input[type="number"]').value);
  }
  var sum = 0;
  for (var i = 0; i < parentlist.length; i++) {
    sum += parentlist[i]
  }
  total.innerHTML = Shopify.formatMoney(((sum) * 100), currencyFormatter)
}

// Decklist Qty Change
function decklistQty(item, action) {
  var lineEdit = document.querySelector('#deckItem' + item).querySelector('input[type="number"]');
  var selectedQty = document.querySelector('#deckItem' + item).querySelector('.selectedAmount');
  var checkbox = document.querySelector('#deckItem' + item).querySelector('input[type="checkbox"]');
  var plusBtn = document.querySelector('#deckItem' + item).querySelector('.addQty');
  var minusBtn = document.querySelector('#deckItem' + item).querySelector('.minusQty');
  var state = document.querySelector('.decklistActions input');
  var maxAvail = parseInt(lineEdit.max);
  var qty = parseInt(lineEdit.value);
  if (action == "add") {
    qty = qty + 1;
    lineEdit.value = qty;
    minusBtn.classList.remove("maxed");
  }
  if (action == "remove") {
    qty = qty - 1;
    lineEdit.value = qty;
    plusBtn.classList.remove("maxed");
  }
  if (qty >= maxAvail) {
    lineEdit.value = maxAvail;
    plusBtn.classList.add("maxed");
  }
  if (qty <= 0 || isNaN(qty)) {
    lineEdit.value = 0;
    checkbox.checked = false;
    minusBtn.classList.add("maxed");
    plusBtn.classList.remove("maxed");
    state.checked = false;
  }
  selectedQty.innerHTML = lineEdit.value;
  decklistTotals();
}
//Toggle Selectall
function toggleall() {
  var state = document.querySelector('.decklistActions input');
  var list = document.querySelectorAll('.decklistItem input');
  if (state.checked == true) {
    list.forEach(function (item) {
      item.checked = true;
    });
    decklistTotals()
  } else {
    list.forEach(function (item) {
      item.checked = false;
    });
    decklistTotals()
  }
}

function toggleOne() {
  var state = document.querySelector('.decklistActions input');
  state.checked = false;
  decklistTotals();
  var state = document.querySelector('.decklistActions input');
  if (state.checked == true) {
    state.checked = false;
  }
}

// Compile / Build Array for processing
function compileDeckList() {
  var list = document.querySelectorAll('.decklistItem input:checked');
  var parentlist = [];
  for (var i = 0; i < list.length; i++) {
    parentlist.push({ id: list[i].parentNode.parentNode.id.substr(8), quantity: list[i].parentNode.parentNode.querySelector('input[type="number"]').value , properties: {}});
  }
  var deckBody = document.querySelector('#deckListBody');
  var loader = document.querySelector('#savedLoader');
  deckBody.innerHTML = loader.innerHTML;
  var message = deckBody.querySelector('.custom-loader p')
  message.innerHTML = "Processing... Please wait"
  addAllItems(parentlist);
}
// Process Deck List

function addAllItems(array) {
  var queue = [];
  for (var i = 0; i < array.length; i++) {
    queue.push(array[i]);
  }
  jQuery.post('/cart/add.js', {
    items: queue
  }, function(){
    getCartItemsUpdate(addAllItemsCallback);
      var primaryColor = document.querySelector('.primaryColour').value;
      Toastify({
        text: "Decklist items added to cart",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      var decklistOverlay = document.querySelector('#decklistOpened');
      decklistOverlay.classList.add('hide');
      var loader = decklistOverlay.querySelector('.custom-loader');
      loader.parentNode.removeChild(loader);
      var buttonText = decklistOverlay.querySelector('#decklistAction button');
      buttonText.innerHTML = "Submit deck list";
      var body = document.querySelector('.bodyScroll');
      body.classList.remove('noscroll');
  },'json');
};

// After decklist has processed . Update Cart quantity
function addAllItemsCallback(value) {
  if (value) {
    var cartCount = document.querySelector('.cart-overview span');
    var mobileCount = document.querySelector('.mobileCartIcon').querySelector('span');
    var cartTotalItems = value.item_count;
    cartCount.innerHTML = cartTotalItems;
    mobileCount.innerHTML = cartTotalItems;
  }
}

// Refresh Wishlist Counts around the site and build wishlist
function refreshWishlistCount() {
  var wishlistOverlay = document.querySelector('.itemsWrapper');
  if (customerId) {
    $.ajax({
      url: (primaryDomain == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/wishlist/forMe?storeUrl=" + primaryDomain + "&shopifyCustomerId=" + customerId,
      type: "GET",
      dataType: "json",
      success: function (result) {
        if (result) {
          var wishlistCount = result.length;
          var accountCount = document.querySelector('.wishlistCount');
          if (accountCount) {
            accountCount.innerHTML = wishlistCount + " items on your wishlist";
          }
          var foundTab = document.querySelector('#binderpos-open-wishlist');
          if (foundTab) {
            foundTab.innerHTML = "My Wishlist (" + wishlistCount + ")";
          }
          if (wishlistOverlay) {
            wishlistOverlay.innerHTML = "";
            result.forEach(function (item) {
              var linkId = item.variants[0].shopifyId;
              var wishlistItem = document.createElement('div');
              wishlistItem.className = "wishlistItem";
              wishlistItem.id = "lineitem-" + item.variants[0].shopifyId;
              wishlistOverlay.appendChild(wishlistItem);
              var img = document.createElement('img');
              img.className = "wishlistImg";
              img.src = item.img;
              var info = document.createElement('div');
              info.className = "wishlistTitle";
              info.innerHTML = item.title + "<br> <em>- " + item.variants[0].title + "</em>";
              var link = document.createElement('a');
              var view = document.createElement('i');
              view.className = "far fa-eye";
              link.appendChild(view);
              var remove = document.createElement('i');
              remove.className = "far fa-trash-alt";
              remove.addEventListener("click", function () {
                if (item.variants && item.variants.length > 0) {
                  removeWishlistLineItem(item.variants[0].shopifyId, primaryDomain, customerId.value)
                } else {
                  //TODO put error somewhere
                }
              });
              var availability = document.createElement('span');
              if (item.variants[0].quantity > 0) {
                availability.className = "availability inStock";
                availability.innerHTML = item.variants[0].quantity + " in Stock";
                link.href = "/products/" + item.handle + "?variant=" + linkId;
              } else {
                availability.className = "availability nilStock";
                availability.innerHTML = "Out of Stock";
                link.href = "/products/" + item.handle;
              }
              info.appendChild(availability);

              wishlistItem.appendChild(img);
              wishlistItem.appendChild(info);
              wishlistItem.appendChild(link);
              wishlistItem.appendChild(remove);
            });
          }
        }
      }
    });
  }
}

//Remove Wihslist Line Item
function removeWishlistLineItem(id, storeUrl, customer) {
  $.ajax({
    url: (storeUrl == "binderpos-dev2.myshopify.com" ? devDomain : prodDomain) + "/external/shopify/wishlist/delete/item/forMe?storeUrl=" + storeUrl + "&shopifyCustomerId=" + customerId + "&shopifyVariantId=" + id,
    type: "DELETE",
    dataType: "json",
    success: function (result) {
      var primaryColor = document.querySelector('.primaryColour').value;
      Toastify({
        text: "Removed from Wishlist",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      var lineItem = document.querySelector("#lineitem-" + id);
      lineItem.parentNode.removeChild(lineItem);
    },
    error: function (result) {
      console.log(result);
    }
  });
}

function predictiveSearch(q, searchPanel, searchLine) {
  var loader = searchPanel.querySelector('.headerSearch img');
  loader.style.opacity = 1;
  if (q == "") {
    searchPanel.classList.add('hide');
    return;
  }
  if (q.length == 1) {
    searchPanel.classList.remove('hide');
  }
  var searchString = document.querySelector('.stringSearch');
  var searchText = searchString.querySelector('a');
  searchText.innerHTML = "\"" + q + "\"";
  searchText.setAttribute('href', '/search?q=*' + q + "*");
  $.ajax({
    url: "/search/suggest.json?q=" + q + "&resources[type]=product",
    type: "GET",
    dataType: "json",
    success: function (result) {
      console.log(result);
      loader.style.opacity = 0;
      searchLine.innerHTML = "";
      var results = result.resources.results.products;
      if (results.length > 0) {
        var i = 0;
        var searchString = document.querySelector('.stringSearch');
        searchString.style.display = "block";
        for (i = 0; i < 5; i++) {
          var resultLine = document.createElement('a');
          if (results[i].url) {
            resultLine.setAttribute('href', results[i].url);
          }
          var img = document.createElement('img');
          img.src = results[i].image;
          resultLine.appendChild(img);
          var infoBox = document.createElement('div');
          infoBox.className = "infoWrapperSearch";
          resultLine.appendChild(infoBox);
          if (results[i].title.match(/(.+) \[(.+)\]/)) {
            var cardName = results[i].title.match(/(.+) \[(.+)\]/)[1];
            var setName = results[i].title.match(/(.+) \[(.+)\]/)[2];
            var productTitle = document.createElement('div');
            productTitle.className = "productTitle";
            productTitle.innerHTML = text_truncate(cardName, 40, '...');
            var setTitle = document.createElement('div');
            setTitle.className = "setTitle";
            setTitle.innerHTML = setName;
            infoBox.appendChild(productTitle);
            infoBox.appendChild(setTitle);
          } else {
            var productTitle = document.createElement('div');
            productTitle.className = "productTitle";
            productTitle.innerHTML = text_truncate(results[i].title, 40, '...');
            infoBox.appendChild(productTitle);
          }
          if (results[i].available) {
            var instock = document.createElement('div');
            instock.className = "available";
            instock.innerHTML = "In stock";
            infoBox.appendChild(instock);
          }
          var price = document.createElement('div');
          if (results[i].price == "0.00") {
            price.innerHTML = "";
            price.className = "priceSearch free";
          } else if (results[i].price_min === results[i].price_max) {
            price.innerHTML = Shopify.formatMoney(((results[i].price) * 100), currencyFormatter);
            price.className = "priceSearch"
          } else {
            price.innerHTML = Shopify.formatMoney(((results[i].price_min) * 100), currencyFormatter) + " - " + Shopify.formatMoney(((results[i].price_max) * 100), currencyFormatter);
            price.className = "priceSearch";
          }
          infoBox.appendChild(price);
          searchLine.appendChild(resultLine);
          searchText.innerHTML = "\"" + q + "\"";
          searchText.setAttribute('href', '/search?q=*' + q + "*");
        }
        searchText.innerHTML = "\"" + q + "\"";
        searchText.setAttribute('href', '/search?q=*' + q + "*");
      } else {
        var noResultsFound = document.createElement('div');
        noResultsFound.className = "noStock";
        noResultsFound.innerHTML = "No results found";
        searchLine.appendChild(noResultsFound);
        var searchString = document.querySelector('.stringSearch');
        searchString.style.display = "none";
      }
    },
    error: function () {
      if (callback) {
        callback(false);
      }
    }
  });
}


// Buylist link Loader
$(document).ready(function () {
  refreshWishlistCount();
  var buylistItems = document.body.querySelectorAll('*[href="#buylist"]');
  buylistItems.forEach(function (buylistItem) {
    buylistItem.addEventListener("click", function (e) {
      e.preventDefault();
      buildBuylistOverlay();
    });
  });
  var decklistItems = document.body.querySelectorAll('*[href="#decklist"]');
  decklistItems.forEach(function (decklistItem) {
    decklistItem.addEventListener("click", function (e) {
      e.preventDefault();
      showDecklist()
    });
  });
  var wishlistItems = document.body.querySelectorAll('*[href="#wishlist"]');
  wishlistItems.forEach(function (wishlistItem) {
    if (customerId == "") {
      wishlistItem.parentNode.style = "display:none";
    }
    wishlistItem.addEventListener("click", function (e) {
      e.preventDefault();
      showWishlist();
    });
  });
  var searchPanel = document.querySelector('.searchResults');
  var searchLine = document.querySelector('.searchLine');
  var searchInput = document.querySelector('.searchBar input');
  searchInput.addEventListener("input", function (e) {
    searchLine.innerHTML = "";
    predictiveSearch(searchInput.value, searchPanel, searchLine);
  });
});

var overlayStyle = 'position: fixed; top: 0; right: 0; z-index: 999999999; width: 85%; height: 100%; background: rgba(0,0,0,0.75);';
var iframeDivStyle = 'text-align: center; position: absolute; width: 100%; height: 100%;';
var closeStyle = 'color:white; position: absolute; top: 8px; left: 3px; height: 3rem; width:3rem; cursor: pointer; font-size: 22px';

function buylistIsInstalled() {
  return window.binderPOSBuylist && window.binderPOSBuylist.portalUrl && window.binderPOSBuylist.portalUrl.length > 0;
}

function buildBuylistOverlay() {
  var currentOverlay = document.querySelector("binderpos-buylist-overlay");
  if (!currentOverlay && buylistIsInstalled()) {
    var buylistOverlay = document.createElement('div');
    buylistOverlay.id = 'binderpos-buylist-overlay';
    buylistOverlay.setAttribute('style', overlayStyle);

    buylistOverlay.addEventListener('click', e => {
      if (e.target == buylistOverlay) {
        removeElement(buylistOverlay);
      }
    });

    var iframeContainer = document.createElement('div');
    iframeContainer.id = 'binderpos-buylist-iframe-container';
    iframeContainer.setAttribute('style', iframeDivStyle);

    iframeContainer.addEventListener('click', e => {
      if (e.target == iframeContainer) {
        removeElement(buylistOverlay);
      }
    })

    var iframeClose = document.createElement('div');
    iframeClose.setAttribute('style', closeStyle);

    var iframeIcon = document.createElement("i");
    iframeIcon.className = "fa fa-times-circle";
    iframeClose.appendChild(iframeIcon);

    iframeClose.addEventListener('click', e => {
      if (e.target == iframeClose || e.target == iframeIcon) {
        removeElement(buylistOverlay);
      }
    })

    iframeContainer.appendChild(iframeClose);

    var iframeContent = document.createElement('iframe');
    iframeContent.className = "binderpos-buylist-iframe";
    iframeContent.setAttribute('style', 'width: 1px !important; min-width: 100%;');
    iframeContent.setAttribute('height', '100%');
    iframeContent.setAttribute('scrolling', 'no');
    iframeContent.setAttribute('frameborder', 0);
    iframeContent.setAttribute('allowfullscreen', 'true');
    iframeContent.src = window.binderPOSBuylist.portalUrl;

    iframeContainer.appendChild(iframeContent);

    buylistOverlay.appendChild(iframeContainer);

    document.body.appendChild(buylistOverlay);
  } else {
    console.log("Buylist not installed");
  }

  function removeElement(node) {
    node.parentNode.removeChild(node);
  }
}


const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
const backLink = `<li class="nav-item">
      <a class="nav-link nav-back-link" href="javascript:;">
        Back
      </a>
    </li>`

navExpand.forEach(item => {
  item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink)
  item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'))
  item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'))
})

const ham = document.getElementById('ham')
ham.addEventListener('click', function () {
  document.body.classList.toggle('nav-is-toggled')
})

var featuredSliders = [];
window.addEventListener('load', function () {
  document.querySelectorAll(".binderpos-mini-slider").forEach(function (sliderElement) {
    featuredSliders.push(new slider(sliderElement, 'ms-slide', "ms-bullet-container"))
  })
});

// Events
$(document).ready(function () {
  loadEvents();
});

let ticketNumber = 1;

function eventdate(change) {
  var currentTime = new Date();
  var month = currentTime.getMonth() + 1;
  var day = currentTime.getDate();
  var year = currentTime.getFullYear() + change;
  var date = year + "-" + month + "-" + day;
  return date
}

function dateFix(item) {
  return new Date(item.date.replace(/T.+/, "") + "T" + item.time)
}

async function loadEvents() {
  var pastEvents = [];
  var upcomingEvents = [];
  var productType = document.querySelector(".productType").value;
  var page = document.querySelector(".pageURL").value;
  var productHandle = document.querySelector(".pageHandle").value;
  var endpoint = "https://betaportal.binderpos.com/api/events/forStore?startDate=" + eventdate(-1) + "&endDate=" + eventdate(+1);
  let response = await fetch(endpoint, {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    })
  });
  if (!response.ok && response.status != 201) {
    let error = await response.json();
    throw error;
  }
  let data = await response.json();
  try {
    data.forEach(event => {
      var eventType = event.type.trim().toLowerCase();
      if (eventType) {
        if (dateFix(event) >= new Date()) {
          upcomingEvents.push(event);
        } else {
          pastEvents.push(event);
        }
      }
    });

    upcomingEvents.sort(function compare(a, b) {
      var dateA = dateFix(a);
      var dateB = dateFix(b);
      return dateA - dateB;
    });
    pastEvents.sort(function compare(a, b) {
      var dateA = dateFix(a);
      var dateB = dateFix(b);
      return dateA - dateB;
    })
    if (page == "collection.events") {
      var tickets = document.querySelectorAll('#ticket');
      tickets.forEach(function (ticket) {
        var productHandleLoop = ticket.getAttribute('data-handle');
        var address = ticket.querySelector('.eventLocation');
        var eventData = data.find(({ handle }) => handle === productHandleLoop)
        if (eventData && eventData.streetAddress) {
          address.innerHTML = eventData.streetAddress + ", " + eventData.city + ", " + eventData.state + " " + eventData.zipCode;
        } else {
          var location = document.querySelector('#location');
          address.innerHTML = location.value;
        }
      });
    }
    if (productType == "Event Ticket") {
      var eventData = data.find(({ handle }) => handle === productHandle)
      buildEventInfo(eventData);
      console.log(eventData)
      console.log(data)
    }
  } catch (e) {
    console.log(e);
  }
}

function buildAdditionalInfo(info) {
  var additionalInfoDiv = document.querySelector('.additionalInfo');
  var infoItem = document.createElement("div");
  infoItem.className = "infoItem";
  additionalInfoDiv.appendChild(infoItem);
  var infoHeader = document.createElement("p");
  infoHeader.className = "header";
  infoHeader.innerHTML = info.header;
  infoItem.appendChild(infoHeader);
  if (info.headerDescription != "") {
    var infoHeaderHelp = document.createElement("p");
    infoHeaderHelp.className = "headerInfoText";
    infoHeaderHelp.innerHTML = info.headerDescription;
    infoItem.appendChild(infoHeaderHelp);
  }
  var infoInput = document.createElement("input")
  infoInput.name = info.id;
  infoItem.appendChild(infoInput);
}

function nthParent(element, n) {
  while (n-- && element)
    element = element.parentNode;
  return element;
}

function updateName(e) {
  var lineItem = nthParent(e.target, 8);
  var fullName = lineItem.querySelector('.participant em');
  var firstName = lineItem.querySelector('input[name="first_name"]').value;
  var lastName = lineItem.querySelector('input[name="last_name"]').value;
  fullName.innerHTML = firstName + " " + lastName;
}

async function buildEventInfo(eventData) {
  console.log(eventData)
  var eventStatus = ""
  var avail = document.querySelector('#ticketsAvailable').value
  var unlimited = false;
  var process = document.querySelector('.addEventBtn');
  var addTicketBtn = document.querySelector('.additionalTicket');
  var ticketUnlimited = document.querySelector('.available');
  var hasSideEvents = false;
  var address = document.querySelector('.eventAddress');
  var foundAddress = eventData.streetAddress;
  if (foundAddress) {
    address.innerHTML = eventData.streetAddress + ", " + eventData.city + ", " + eventData.state + " " + eventData.zipCode;
  } else {
    var location = document.querySelector('#location');
    address.innerHTML = location.value;
  }
  if (eventData.linkedEvents.length > 0) {
    hasSideEvents = true;
  }
  if (eventData.maxParticipants == "0" && avail <= 0) {
    var unlimited = true;
  }
  if (dateFix(eventData) >= new Date()) {
    eventStatus = "open";
  } else {
    eventStatus = "closed";
  }
  if (eventStatus == "closed" || (eventData.maxParticipants > "0" && avail <= 0)) {
    var defaultTicket = document.querySelector('.ticketItem');
    defaultTicket.remove();
  }
  if (unlimited || avail > 0) {
    if (eventStatus == "open") {
      process.disabled = false;
      process.innerHTML = "Add to Cart <i class='fas fa-angle-right'></i>";
      if (unlimited && eventStatus == "open") {
        ticketUnlimited.innerHTML = "Unlimited Tickets";
      } else {
        ticketUnlimited.innerHTML = "Available Tickets: <em>" + avail + "</em>";
      }
      addTicketBtn.innerHTML = "<i class='fas fa-user-plus'></i> Add a ticket"
      addTicketBtn.addEventListener("click", function () {
        newTicket(unlimited);
      });
    } else {
      addTicketBtn.innerHTML = "Event Finished";
      var totalsDiv = document.querySelector('.totals');
      var registerBtn = document.querySelector('.registerBtn');
      registerBtn.remove();
      totalsDiv.remove();
    }
  } else {
    //todo
  }
  var productId = document.querySelector('#productId').value;
  var additionalInfo = eventData.additionalInfo;
  if (additionalInfo.length > 0 && (unlimited || avail > 0)) {
    var additionalInfoDiv = document.querySelector('.additionalInfo');
    additionalInfoDiv.innerHTML = "";
    var ticketInfoDiv = document.querySelector('.ticketInfo');
    var arrow = document.querySelector('.arrow');
    ticketInfoDiv.classList.add('expand');
    arrow.classList.add('fa-angle-down')
    arrow.classList.remove('fa-angle-right')
    additionalInfo.forEach(function (info) {
      buildAdditionalInfo(info);
    });
  }
  if (hasSideEvents) {
    var registerWrapper = document.querySelector('.registerWrapper')
    var sideEventDiv = document.createElement('div');
    sideEventDiv.className = "sideEventsWrapper";
    sideEventDiv.innerHTML = "<h3 style='margin-top:40px;'>Add ons available</h3>"
    registerWrapper.appendChild(sideEventDiv);
    eventData.linkedEvents.forEach(function (linked) {
      if (!linked.isDisabled) {
        checkShopifyId(linked.handle)
        var sideEventItemDiv = document.createElement('div');
        sideEventItemDiv.id = linked.handle;
        sideEventItemDiv.setAttribute('data-price', linked.ticketPrice ? linked.ticketPrice : "0")
        sideEventItemDiv.className = "sideEventItem";
        sideEventDiv.appendChild(sideEventItemDiv);
        var labelContainer = document.createElement('label');
        labelContainer.className = "labelContainer";
        sideEventItemDiv.appendChild(labelContainer);
        var sideEventCheckbox = document.createElement('input');
        sideEventCheckbox.className = "sideEventCheckbox"
        sideEventCheckbox.type = "checkbox"
        sideEventCheckbox.name = "addons[]"
        sideEventCheckbox.onchange = function () {
          refreshTicketId(unlimited)
        }
        labelContainer.appendChild(sideEventCheckbox);
        var checkboxSpan = document.createElement('span');
        checkboxSpan.className = "checkmark";
        labelContainer.appendChild(checkboxSpan);
        var sideEventTitle = document.createElement('p');
        sideEventTitle.className = "sideEventTitle";
        sideEventTitle.innerHTML = linked.title.trim() + " [Side Event]";
        sideEventItemDiv.appendChild(sideEventTitle);
        var sideEventPrice = document.createElement('p');
        sideEventPrice.className = "sideEventprice";
        sideEventPrice.innerHTML = Shopify.formatMoney(((linked.ticketPrice) * 100), currencyFormatter) + " / per person";
        sideEventItemDiv.appendChild(sideEventPrice);
        var container = document.createElement('section')
        container.className = "qtyContainer";
        sideEventItemDiv.appendChild(container);
        var containerDiv = document.createElement('div');
        containerDiv.className = "product-quantity";
        containerDiv.innerHTML = "<h5>Quantity</h5><input id=" + linked.handle + " data-min='1' data-max='0' type='text' name='quantity' value='1' readonly='true'><div class='quantity-selectors-container'><div class='quantity-selectors'><button type='button' class='increment-quantity' data-itemid=" + linked.handle + " aria-label='Add one' data-direction='1'><span>&#43;</span></button><button type='button' class='decrement-quantity' data-itemid=" + linked.handle + " aria-label='Subtract one' data-direction='-1' disabled='disabled'><span>&#8722;</span></button></div></div>"
        container.appendChild(containerDiv);
      }
    });
  }
  $(".increment-quantity,.decrement-quantity").on("click", function () {
    var qtyDirection = $(this).data("direction");
    var id = $(this).data("itemid");
    var newQty = 0;
    var qtySelector = document.querySelector('#' + id)
    var qtySelectorInput = qtySelector.querySelector('input[type=text]')
    var currentQty = qtySelectorInput.value
    if (qtyDirection == "1") {
      newQty = parseInt(currentQty) + 1;
    }
    else if (qtyDirection == "-1") {
      newQty = parseInt(currentQty) - 1;
    }
    if (newQty == 1) {
      qtySelector.querySelector('.decrement-quantity').setAttribute("disabled", "disabled");
    }
    if (newQty > 1) {
      qtySelector.querySelector('.decrement-quantity').removeAttribute("disabled");
    }
    if (newQty > 0) {
      qtySelectorInput.value = newQty
    }
    else {
      qtySelectorInput.value = 1;
    }
    refreshTicketId(unlimited)
  });
  refreshTicketId(unlimited)
}

async function checkShopifyId(handle) {
  var endpoint = "/products/" + handle + ".js";
  let response = await fetch(endpoint, {
    method: "GET"
  });
  if (!response.ok && response.status != 201) {
    let error = await response.json();
    throw error;
  }
  let data = await response.json();
  try {
    var linkedItemCheckbox = document.querySelector('#' + handle + ' .sideEventCheckbox')
    linkedItemCheckbox.id = data.variants[0].id;
  } catch (e) {
    console.log(e);
  }
}

function refreshTicketId(unlimited) {
  var tickets = document.querySelectorAll('.ticketItem');
  var subEvents = document.querySelectorAll('.sideEventItem');
  var avail = parseInt(document.querySelector('#ticketsAvailable').value);
  var i = 0;
  var z = 0
  var total = 0;
  tickets.forEach(function (ticket) {
    ticket.id = "ticket-" + z;
    z++
  });
  tickets.forEach(function (ticket) {
    var lineItem = document.querySelector('#ticket-' + i);
    total = (total + parseInt(lineItem.getAttribute('data-price')));
    var deleteItem = lineItem.querySelector('.deleteItem');
    lineItem.onclick = null;
    var ticketNumber = "ticket-" + i;
    lineItem.onclick = function () {
      ticketInfoToggle(event, ticketNumber)
    }
    if (deleteItem) {
      deleteItem.onclick = null
      deleteItem.onclick = function () {
        deleteTicket(ticketNumber, unlimited)
      }
    }
    if (!unlimited) {
      ticket.querySelector('.available em').innerHTML = avail;
    }
    i++
    avail--
  });
  if (subEvents) {
    subEvents.forEach(function (subEvent) {
      if (subEvent)
        var selected = subEvent.querySelector('.sideEventCheckbox')
      if (selected.checked) {
        var qty = subEvent.querySelector('input[type=text]').value;
        total = (total + (parseInt(subEvent.getAttribute('data-price')) * qty));
      }
    })
  };
  var ticketTotals = document.querySelector('.eventTotal em');
  ticketTotals.innerHTML = Shopify.formatMoney(((total) * 100), currencyFormatter);
}
function deleteTicket(lineId, unlimited) {
  var lineItem = document.querySelector('#' + lineId);
  lineItem.remove();
  refreshTicketId(unlimited)
}

function newTicket(unlimited) {
  var existing = document.querySelectorAll('.ticketItem')
  existing.forEach(function (ticketItem) {
    ticketItem.querySelector('.ticketInfo').classList.remove('expand')
    var arrow = ticketItem.querySelector('.arrow');
    arrow.classList.remove('fa-angle-down')
    arrow.classList.add('fa-angle-right')
  });
  var ticketWrapper = document.querySelector('#mainEventTickets');
  var available = document.querySelector('#ticketsAvailable').value
  var existingTickets = document.querySelectorAll('.ticketItem').length
  var ticketID = document.querySelector('.ticketItem').getAttribute('data-id');
  var price = document.querySelector('.ticketItem').getAttribute('data-price');
  var title = document.querySelector('.ticketItem').querySelector('.title').innerHTML
  var imgSrc = document.querySelector('.ticketItem').querySelector('img').src
  var oldInfo = document.querySelector('.ticketItem').querySelector('.additionalInfo').innerHTML
  if (existingTickets < available || unlimited) {
    var ticketItem = document.createElement('div');
    ticketItem.className = "ticketItem";
    ticketItem.setAttribute("data-id", ticketID);
    ticketItem.setAttribute("data-price", price);
    ticketWrapper.appendChild(ticketItem);
    var deleteIcon = document.createElement('i');
    deleteIcon.className = "deleteItem far fa-trash-alt";
    ticketItem.appendChild(deleteIcon);
    var icon = document.createElement('i');
    icon.className = "arrow fas fa-angle-down"
    ticketItem.appendChild(icon);
    var img = document.createElement('img')
    img.src = imgSrc;
    ticketItem.appendChild(img);
    var titleDiv = document.createElement('div');
    titleDiv.className = "title";
    titleDiv.style = "padding-left:8px;"
    titleDiv.innerHTML = title;
    ticketItem.appendChild(titleDiv);
    var availDiv = document.createElement('div');
    availDiv.className = "available";
    if (!unlimited) {
      availDiv.innerHTML = "Available Tickets: ";
      ticketItem.appendChild(availDiv);
      var availCount = document.createElement('em');
      availCount.innerHTML = available - existingTickets
      availDiv.appendChild(availCount);
    } else {
      availDiv.innerHTML = "Unlimited Tickets";
      ticketItem.appendChild(availDiv);
    }
    var participant = document.createElement('div');
    participant.className = "participant";
    participant.innerHTML = "Participant: "
    ticketItem.appendChild(participant);
    var particpantName = document.createElement('em');
    particpantName.innerHTML = "Unknown Currently";
    participant.appendChild(particpantName);
    var ticketInfo = document.createElement('div')
    ticketInfo.className = "ticketInfo expand";
    ticketItem.appendChild(ticketInfo);
    var ticketInfoContainer = document.createElement('div')
    ticketInfoContainer.className = "container";
    ticketInfo.appendChild(ticketInfoContainer);
    var ticketInfoRow = document.createElement('div')
    ticketInfoRow.className = "row";
    ticketInfoContainer.appendChild(ticketInfoRow);
    var col = document.createElement('div');
    col.className = "col-md-8";
    col.style = "padding-right: 1px; padding-left: 0px;"
    ticketInfoRow.appendChild(col);
    var wrapper = document.createElement('div')
    wrapper.className = "wrapper";
    col.appendChild(wrapper);
    var h5 = document.createElement('h5');
    h5.innerHTML = "Participants Information";
    wrapper.appendChild(h5);
    var participantsInfo = document.createElement('div')
    participantsInfo.className = "participantsInfo"
    wrapper.appendChild(participantsInfo);
    var span = document.createElement('span');
    participantsInfo.appendChild(span);
    var p = document.createElement('p');
    p.innerHTML = "First Name *";
    span.appendChild(p);
    var input = document.createElement('input');
    input.type = "text";
    input.name = "first_name"
    input.required = true;
    input.addEventListener('keyup', function () {
      updateName(event)
    });
    span.appendChild(input);
    var span = document.createElement('span');
    participantsInfo.appendChild(span);
    var p = document.createElement('p');
    p.innerHTML = "Last Name *";
    span.appendChild(p);
    var input = document.createElement('input');
    input.type = "text";
    input.name = "last_name"
    input.required = true;
    input.addEventListener('keyup', function () {
      updateName(event)
    });
    span.appendChild(input);
    var col = document.createElement('div');
    col.className = "col-md-4";
    col.style = "padding-right: 0px; padding-left: 1px;"
    ticketInfoRow.appendChild(col);
    var wrapper = document.createElement('div')
    wrapper.className = "wrapper";
    col.appendChild(wrapper);
    var h5 = document.createElement('h5');
    h5.innerHTML = "Additional Information";
    wrapper.appendChild(h5);
    var additionalInfo = document.createElement('div')
    additionalInfo.className = "additionalInfo";
    additionalInfo.innerHTML = oldInfo;
    wrapper.appendChild(additionalInfo);
  }
  ticketNumber++
  refreshTicketId(unlimited)
}

function prepareEvent() {
  var array = [];
  var tickets = document.querySelectorAll('.ticketItem');
  var subEvents = document.querySelectorAll('.sideEventItem');
  tickets.forEach(function (ticket, ticketIndex) {
    var itemId = ticket.getAttribute('data-id');
    var inputs = ticket.querySelectorAll('input');
    var props = {};
    inputs.forEach(function (input) {
      if (!input.validity.valid) {
        const friendlyName = input.name.replace(/_/, ' ');
        const message = `Ticket #${ticketIndex + 1} is missing ${friendlyName}`;
        alert(message);
        throw new Error(message);
      }
      props[input.name] = input.value;
    });
    var obj = {
      quantity: 1,
      id: itemId,
      properties: props
    }
    array.push(obj);
  });
  if (subEvents) {
    subEvents.forEach(function (subEvent) {
      if (subEvent)
        var selected = subEvent.querySelector('.sideEventCheckbox')
      var qty = subEvent.querySelector('input[type=text]').value
      if (selected.checked) {
        var obj = {
          quantity: qty,
          id: selected.id
        }
        array.push(obj);
      }
    })
  };
  processEvent(array)
}

function processEvent(array) {
  Shopify.queue = [];
  for (var i = 0; i < array.length; i++) {
    Shopify.queue.push(array[i]);
  }
  Shopify.moveAlong = function () {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      var data = request
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        success: function (res) {
          Shopify.moveAlong();
        },
        error: function () {
          if (Shopify.queue.length) {
            Shopify.moveAlong()
          }
        }
      });
    } else {
      var primaryColor = document.querySelector('.primaryColour').value;
      getCartItemsUpdate(addAllItemsCallback);
      Toastify({
        text: "Cart Updated",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        backgroundColor: primaryColor,
        stopOnFocus: true // Prevents dismissing of toast on hover
      }).showToast();
      var modal = document.querySelector('.modal')
      modal.innerHTML = "<div class='success-checkmark'><div class='check-icon'><span class='icon-line line-tip'></span><span class='icon-line line-long'></span><div class='icon-circle'></div><div class='icon-fix'></div></div></div><p class='successText'>Success</p><p class='successInfo'>Thankyou for registering for the event. Don't forget to checkout to finalise the registration.</p><a href='/checkout'><div class='checkoutBtn'><i class='fas fa-shopping-cart'></i> Proceed to Checkout </div></a>";
      modal.style = "max-height: 417px !important;"
    }
  };
  Shopify.moveAlong();
};

function ticketInfoToggle(e, item) {
  var ticketItem = document.querySelector('#' + item)
  if (ticketItem) {
    var ticketInfoDiv = ticketItem.querySelector('.ticketInfo');
    var arrow = ticketItem.querySelector('.arrow');
    if (e.target.className == "ticketItem" || e.target.className == "participant" || e.target.className == "title" || e.target.className == "available" || e.target.className == "arrow fas fa-angle-right" || e.target.className == "arrow fas fa-angle-down" || e.target.tagName == "IMG" || e.target.tagName == "EM") {
      ticketInfoDiv.classList.toggle('expand');
    }
    if (ticketInfoDiv.classList.contains('expand')) {
      arrow.classList.add('fa-angle-down')
      arrow.classList.remove('fa-angle-right')
    } else {
      arrow.classList.remove('fa-angle-down')
      arrow.classList.add('fa-angle-right')
    }
  }
}

text_truncate = function (str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

function stripHtml(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}